'use strict';

angular.module('webAgro1App').directive('agroScroll', function($timeout) {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      element.addClass('hidden');

      var scrollInitializePosition = attrs.scrollInitializePosition;
      var scrollTop = Number(attrs.scrollTop);
      var scrollLeft = Number(attrs.scrollLeft);
      var scrollElement = null;
      var timer;

      var setVisibleElement = function() {
        if (scrollTop > 0) {
          var altura = (scrollElement[0].scrollHeight - scrollElement.innerHeight());
          if (scrollElement.scrollTop() >= altura) {
            element.addClass('hidden');
          } else {
            element.removeClass('hidden');
          }
        } else {
          if (scrollElement.scrollTop() <= 0) {
            element.addClass('hidden');
          } else {
            element.removeClass('hidden');
          }
        }
      };

      var setScrollTopElement = function() {
        scrollElement.stop().animate({scrollTop: scrollElement.scrollTop() + scrollTop}, '50');
      };

      $timeout(function() {
        scrollElement = $('#' + attrs.scrollElementId);
        if (scrollElement.length && (scrollTop || scrollLeft)) {
          scrollElement.addClass('agro-scroll');

          if (scrollInitializePosition === 'bottom') {
            scrollElement.scrollTop(scrollElement[0].scrollHeight);
          }

          if (scrollTop) {
            scrollElement.scroll(function() {
              setVisibleElement();
            });

            element.hover(function() {
              timer = setInterval(function() {
                setScrollTopElement();
              }, 400);
            }, function() {
              clearInterval(timer);
            });

            element.on('click', function() {
              setScrollTopElement();
            });

            setVisibleElement();
          }
        }
      }, 100);
    }
  };
});
